type Gender = {
	uuid: string;
	label: string;
	value: string;
};

export const genders: Gender[] = [
	{
		uuid: "9de1638c-bb15-4e68-bbd0-07660091210e",
		label: "Male",
		value: "MALE",
	},
	{
		uuid: "9de1638c-bb23-4657-b375-41d3a7188e5d",
		label: "Female",
		value: "FEMALE",
	},
	{
		uuid: "9de1638c-bb26-4cf3-9f68-10d67b52c687",
		label: "Other",
		value: "OTHER",
	},
];
